import { useQuery } from "@tanstack/react-query";
import { getTemplate } from "../../../services/smsTemplateServices";
import SmsTemplatesHandler from "../../../components/admin/messages/SmsTemplatesHandler";

const SmsTemplates = () => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["templates"],
    queryFn: getTemplate,
  });

  if (isLoading) return <div>Loading templates...</div>;
  if (error) return <div>Failed to load templates.</div>;

  return <SmsTemplatesHandler template={data?.data} onRefresh={refetch} />;
};

export default SmsTemplates;
